const React = require('react');

function jsx(type, props, maybeKey) {
  const next = props ? { ...props } : {};
  if (maybeKey !== undefined) {
    next.key = maybeKey;
  }
  return React.createElement(type, next);
}

module.exports = {
  Fragment: React.Fragment,
  jsx,
  jsxs: jsx,
};
